import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import { Card } from '@components/ui';

import { BlogPostData } from '../types';

type BlogPostProps = BlogPostData;

const BlogPost: LitheFC<BlogPostProps> = ({
  id = 'blog-post',
  testId = 'blog-post',
  slug,
  title,
  lead,
  created,
  author,
}): LitheElement<'li'> => [
  'li',
  { id, 'data-testid': testId },
  [
    'a',
    {
      href: `/blog/${slug}`,
      class: 'no-underline text-text',
    },
    Card(
      {},
      ['h3', { class: 'text-primary text-2xl' }, title],
      ['p', { class: 'my-2' }, lead],
      [
        'small',
        ['span', new Date(created).toLocaleString()],
        ['span', ', '],
        ['span', author],
      ]
    ),
  ],
];

export default BlogPost;
